// extracted by mini-css-extract-plugin
export default {"m":"c55969fa76","title":"aefd03e4b0","feedback_inner_title":"fbe40595b0","textarea":"d4d404c02b","radio":"_8ba239f9f9","text":"b088e06144"};